import fb from '../firebase'

var db = fb.database()

const state = {
    clipboard: {
        element: null,
        elements: null,
        action: null
    }
}

// getters
const getters = {

    clipboard: state => {
        return state.clipboard
    },
}

// actions
const actions = {

}

// mutations
const mutations = {

    clipboard (state, clipboard) {
        state.clipboard = clipboard           
    },              
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/ClipboardStore.js